import { makeStyles } from '@mui/styles';
import notStartedSrc from '../../images/course-not-started.svg';
import oneThirdSrc from '../../images/course-one-third.svg';
import twoThirdSrc from '../../images/course-two-third.svg';
import lastThirdSrc from '../../images/course-last-third.svg';

const IMG_SIZE = 180;
const IMG_SIZE_SMALL = 132;

const useStyles = makeStyles(
  ({ breakpoints }) => ({
    image: {
      height: IMG_SIZE_SMALL,
      width: IMG_SIZE_SMALL,
      [breakpoints.up('sm')]: {
        height: IMG_SIZE,
        width: IMG_SIZE,
      },
    },
  }),
  { classNamePrefix: 'PictureProgression' }
);

export interface ProgressionPictureProps {
  progression: number;
}

function ProgressionPicture({ progression }: ProgressionPictureProps) {
  const classes = useStyles();

  if (progression === 0) {
    return <img src={notStartedSrc} alt="" className={classes.image} data-testid="not-started" />;
  }

  if (progression < 33) {
    return <img src={oneThirdSrc} alt="" className={classes.image} data-testid="one-third" />;
  }

  if (progression < 66) {
    return <img src={twoThirdSrc} alt="" className={classes.image} data-testid="two-third" />;
  }

  return <img src={lastThirdSrc} alt="" className={classes.image} data-testid="last-third" />;
}

export default ProgressionPicture;
